import axios from 'axios';
import environment from '../environment/enviroment';

const urlApi = environment.apiUrl;

const auth = axios.create({ baseURL: urlApi });
const authNotInterceptor = axios.create({ baseURL: urlApi });

let isRefreshing = false;
let refreshSubscribers: ((token: string) => void)[] = [];

function onRefreshed(token: string) {
  refreshSubscribers.forEach(cb => cb(token));
  refreshSubscribers = [];
}

function addRefreshSubscriber(cb: (token: string) => void) {
  refreshSubscribers.push(cb);
}

auth.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  const userStr = localStorage.getItem('user');

  if (!config.headers) {
    config.headers = {} as any;
  }

  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }

  config.params = {
    ...config.params,
    ...(userStr ? { i: JSON.parse(userStr).companies[0].id } : {}),
  };

  return config;
}, error => Promise.reject(error));

authNotInterceptor.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  config.params = {
    ...config.params,
    token,
  };
  return config;
}, error => Promise.reject(error));

async function doRefreshToken(): Promise<string> {
  const token = localStorage.getItem('token');
  authNotInterceptor.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  const response = await authNotInterceptor.post('/refresh');
  const newToken = response.data.token;
  if (typeof newToken === 'string') {
    localStorage.setItem('token', newToken);
    return newToken;
  }
  throw new Error('Refresh não retornou token válido');
}

auth.interceptors.response.use(
  response => response,
  error => {
    const { config, response: res } = error;
    if (!res || res.status !== 401) {
      return Promise.reject(error);
    }

    if (!isRefreshing) {
      isRefreshing = true;
      doRefreshToken()
        .then(token => {
          isRefreshing = false;
          onRefreshed(token);
        })
        .catch(err => {
          isRefreshing = false;
          console.error('Falha ao renovar token', err);
        });
    }

    return new Promise((resolve, reject) => {
      addRefreshSubscriber(token => {
        config.headers['Authorization'] = `Bearer ${token}`;
        resolve(axios(config));
      });
    });
  }
);

export default auth;
